/**
 * Spanish line-plot prompts and data titles (ADR 0084 §5). Same shape as the
 * English file. "X" is feminine (la equis) and "puntos" masculine, so each
 * mark has its own sentence rather than a word slotted into one.
 */
/** The mark's `LinePlotMarkOptions` value: 'X' or 'Dot'. */
type Mark = string;

export const linePlotPrompts = {
    readOne: (value: string, mark: Mark) =>
        mark === 'Dot' ? `¿Cuántos puntos hay sobre ${value}?` : `¿Cuántas X hay sobre ${value}?`,
    // "sobre", not "encima de": with "encima de" twice, the sentence wrapped
    // to two lines and eight questions spilled onto a second page (measured).
    difference: (more: string, fewer: string, mark: Mark) =>
        mark === 'Dot'
            ? `¿Cuántos puntos más hay sobre ${more} que sobre ${fewer}?`
            : `¿Cuántas X más hay sobre ${more} que sobre ${fewer}?`,
    total: (mark: Mark) => (mark === 'Dot' ? `¿Cuántos puntos hay en total?` : `¿Cuántas X hay en total?`),
    mostCommon: () => `¿Qué valor aparece más veces?`,
    range: () => `¿Cuánto es el valor mayor menos el valor menor?`,
    median: () => `¿Cuál es la mediana de los datos?`,
};

export const linePlotContexts: {
    counted: { title: string; start: [number, number] }[];
    measured: { title: string; start: [number, number] }[];
} = {
    counted: [
        { title: 'Libros que leyó cada estudiante este mes', start: [0, 4] },
        { title: 'Goles marcados en cada partido', start: [0, 1] },
        { title: 'Letras de cada nombre', start: [2, 4] },
        { title: 'Puntos obtenidos en cada ronda', start: [0, 12] },
        { title: 'Flexiones que hizo cada estudiante', start: [5, 12] },
    ],
    measured: [
        { title: 'Largo de las cintas (pulgadas)', start: [1, 6] },
        { title: 'Largo de los lápices (pulgadas)', start: [2, 5] },
        { title: 'Largo de las lombrices (pulgadas)', start: [1, 3] },
        { title: 'Peso de los cachorros (libras)', start: [2, 8] },
        { title: 'Agua en cada botella (tazas)', start: [0, 2] },
        { title: 'Distancia que corrió cada estudiante (millas)', start: [0, 3] },
    ],
};
